import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { allowUserSendMessages } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { useAlertsUrl } from '../../../../hooks/useAlertsUrl';
import { InboxCard } from '../../../inbox/components/InboxCard';
import { CreateNotificationButton } from '../AlertsList/components/CreateNotificationButton';
export const NotificationsWidget = (props) => {
    const alertsInboxUrlFromConfig = useAlertsUrl('inbox');
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const userState = useUserState();
    const allowSendMessages = allowUserSendMessages(userState);
    return (React.createElement(InboxCard, { onRequireResponseClick: () => navigationContext.navigate(() => {
            const urlParams = new URLSearchParams();
            urlParams.set('filter', JSON.stringify({ status: ['waiting'] }));
            navigationContext.navigate(() => { var _a; return navigate({ pathname: (_a = props.alertsInboxUrl) !== null && _a !== void 0 ? _a : alertsInboxUrlFromConfig, search: urlParams.toString() }); });
        }), onUnreadClick: () => {
            const urlParams = new URLSearchParams();
            urlParams.set('filter', JSON.stringify({ status: ['unread'] }));
            navigationContext.navigate(() => { var _a; return navigate({ pathname: (_a = props.alertsInboxUrl) !== null && _a !== void 0 ? _a : alertsInboxUrlFromConfig, search: urlParams.toString() }); });
        }, headerAction: allowSendMessages ? (React.createElement(Box, { sx: { ml: 2 } },
            React.createElement(CreateNotificationButton, { alertsSentUrl: props.alertsSentUrl }))) : null }));
};
